import type { FunctionComponent } from 'react';

import { Field, Form } from '@kanda-libs/ks-component-ts';

import usePartnersAnalytics from './usePartnersAnalytics';

const PartnersAnalaytics: FunctionComponent = function () {
  const { form, showAnalytics, totalSubscriptions, totalActivations } =
    usePartnersAnalytics();

  if (!showAnalytics) return <></>;

  return (
    <Form id="staff-partners-analytics" form={form} onSubmit={() => {}}>
      <div className="my-4">
        <Field.DatePickerInput name="filterDate" label="Filter stats by date" />
      </div>
      <ul className="mt-4 mb-2 text-14-22-em text-lavender-200">
        <li>Total subscribers: {totalSubscriptions}</li>
        <li>Total activations: {totalActivations}</li>
      </ul>
    </Form>
  );
};

export default PartnersAnalaytics;
